import LocalizedStrings from 'react-localization';
import { withCommon } from '../../services/translation/commonTranslations';

const devicesStrings = new LocalizedStrings({
  en: {
    manageOrgSection: {
      title: 'Manage Organisation',
      orgDetailsCard: {
        title: 'Organisation Details',
        name: 'Organisation Name',
        logo: 'Organisation Logo'
      },
      structureCard: {
        title: 'Organisation Structure',
        desc: 'View your organisation as a clear hierarchy of divisions and locations'
      },
      locationCard: {
        title: 'Locations',
        desc: 'Add new locations and manage existing ones'
      },
      stationsCard: {
        title: 'Stations',
        desc: 'Add new locations and manage existing ones'
      }
    },
    locationsSection: {
      title: 'Locations',
      noData: 'No locations to display'
    },
    organisationStructureSection: {
      title: 'Organisation Structure',
      overviewTitle: 'Structure Overview',
      overviewDescription: 'Browse the organisation by division and location.',
      treeTitle: 'Browse Organisation',
      detailsTitle: 'Details',
      treeDescription: 'Expand only the branches you need.',
      detailsDescription: 'View the direct child divisions and locations for the selected node.',
      directDivisions: 'Direct divisions',
      totalDivisions: 'Total divisions',
      totalLocations: 'Total locations',
      rootLocations: 'Direct locations',
      noData: 'No organisation structure to display',
      childDivisions: 'Child divisions',
      locations: 'Locations',
      noChildDivisions: 'No child divisions',
      noLocations: 'No locations',
      browseHint: 'Select a division or location from the tree.',
      viewLabel: 'View',
      divisionLabel: 'Division',
      locationLabel: 'Location',
      parentLabel: 'Parent',
      currentSelection: 'Current selection',
      employees: 'Employees',
      managers: 'Managers',
      seniorManagers: 'Senior Managers',
      noEmployees: 'No employees',
      noManagers: 'No managers',
      noSeniorManagers: 'No senior managers'
    },
    addLocationModal: {
      title: 'Add New Location',
      nameField: 'Location name',
      namePlaceholder: 'Name',
      nameRequired: 'Location name required',
      uniqueName: 'Location name must be unique.'
    },
    locationHolidayRegion: {
      label: 'Holiday region',
      description: 'Select the public holiday region used for this location.',
      inheritOption: 'Use tenant default'
    }
  }
});

export default withCommon<typeof devicesStrings>(devicesStrings);
